/**
 * Tab nộp dự toán
 * tvanh 02.04.2024
 */
export default {
  REVENUE: 1, // thu(xã)
  EXPENSE: 2, // chi(xã)
  SYMMETRIC: 3, // cân đối(xã)
  SUMMARY: 4, // tổng hợp(hscn)
  DETAIL: 5 // chi tiết (hcsn)
};